import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Hmain1 from './Hmain1';
import '../css/home.css';
import Hmain2 from './Hmain2';
import Footer from './Footer';
import HomeSlider from './HomeSlider';
import '../css/homeslider.css';

function Home() {
  const [isAiOpen, setIsAiOpen] = useState(false);
  const [aiMessage, setAiMessage] = useState('');

  useEffect(() => {
    const handleLoad = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  const handleAiSubmit = (e) => {
    e.preventDefault();
    // Process AI input here
    console.log("AI Query:", aiMessage);
    setAiMessage('');
    // You could add an API call here for a real AI response
  };

  const toggleAiAssistant = () => {
    setIsAiOpen(!isAiOpen);
  };

  return (
    <div className='home'>
      <Navbar page={'home'} />
      <Hmain1 />
      <HomeSlider />
      <Footer page={'home'} />

      {/* AI Assistant */}
      {/* <div className={`ai-assistant ${isAiOpen ? 'open' : ''}`}>
        <div className="ai-toggle" onClick={toggleAiAssistant}>
          <span className="ai-icon-symbol">✱</span>
        </div>
        <div className="ai-content">
          <div className="ai-header">
            <div className="ai-icon">
              <span className="ai-icon-symbol">✱</span>
            </div>
            <h3 className="ai-title">Hello I'm Aizre</h3>
            <button className="ai-close" onClick={toggleAiAssistant}>
              <span>×</span>
            </button>
          </div>
          <p className="ai-description">
            Red Fibre's Executive AI.<br/>
            Let me know your business
          </p>
          <form className="ai-input" onSubmit={handleAiSubmit}>
            <input
              type="text"
              placeholder="Start typing.."
              value={aiMessage}
              onChange={(e) => setAiMessage(e.target.value)}
            />
            <button type="submit" className="ai-send">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </form>
        </div>
      </div> */}
    </div>
  );
}

export default Home;
